module.exports = __webpack_public_path__ + "static/media/notification_promo_icon.455abdfa.svg";